class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    if (document.querySelector(".cart-shipping")) {
      this.minSpend = document.querySelector(".cart-shipping").dataset.minSpend;
      this.minTotal = Math.round(this.minSpend * (Shopify.currency.rate || 1));
      this.cartShipping();
    }

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  cartShipping() {
    let progressPrev = getComputedStyle(
      document.querySelector(".cart-shipping__progress-current")
    ).getPropertyValue("width");
    document.documentElement.style.setProperty("--progress-prev", progressPrev);

    this.total = document.querySelector(".cart-shipping").dataset.total;
    this.progress = (this.total / this.minTotal) * 100;
    if (this.progress > 100) this.progress = 100;

    if (this.minTotal > this.total) {
      let amount = this.minTotal - this.total;
      let message = document
        .querySelector(".cart-shipping")
        .dataset.message.replace("||amount||", formatMoney(amount));
      document.querySelector(".cart-shipping__message_default").innerText =
        message;
      document
        .querySelector(".cart-shipping__message_success")
        .classList.remove("active");
      document
        .querySelector(".cart-shipping__message_default")
        .classList.add("active");

      if (document.querySelector(".totals__shipping-value")) {
        document.querySelector(".totals__shipping-value").innerText =
          window.cartShipping.calculated;
      }
    } else {
      document
        .querySelector(".cart-shipping__message_default")
        .classList.remove("active");
      document
        .querySelector(".cart-shipping__message_success")
        .classList.add("active");
      if (document.querySelector(".totals__shipping-value")) {
        document.querySelector(".totals__shipping-value").innerText =
          window.cartShipping.free;
      }
    }

    document.querySelector(".cart-shipping__progress-current").style.width =
      this.progress + "%";
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents-totals",
      },
      {
        id: "main-cart-shipping",
        section:
          document.getElementById("main-cart-shipping").dataset.id || null,
        selector: ".js-contents-shipping",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll(".quantity__button").forEach((button) =>
      button.classList.add("disabled")
    );

    if (
      document.querySelectorAll(
        '.card--product card__add-to-cart button[name="add"]'
      )
    ) {
      document
        .querySelectorAll(
          '.card--product .card__add-to-cart button[name="add"]'
        )
        .forEach((button) => {
          button.setAttribute("aria-disabled", false);
          if (button.querySelector("span")) {
            button.querySelector("span").classList.remove("hidden");
            button.querySelector(".sold-out-message").classList.add("hidden");
          }
        });
    }

    if (document.querySelector(".cart-shipping")) {
      let progressPrev = getComputedStyle(
        document.querySelector(".cart-shipping__progress-current")
      ).getPropertyValue("width");
      document.documentElement.style.setProperty(
        "--progress-prev",
        progressPrev
      );
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const items = document.querySelectorAll(".cart-item");

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);

          // dispatch cart:error
          document.dispatchEvent(
            new CustomEvent("cart:error", {
              detail: {
                source: this.dataset.source,
                productVariantId: items[line - 1].dataset.variantId || line,
                errors: parsedState.errors,
                message: parsedState.errors,
              },
            })
          );
          return;
        }

        // dispatch line-item:change for the modified element
        document.dispatchEvent(
          new CustomEvent("line-item:change", {
            detail: {
              lineItem: parsedState.items[line - 1] || null,
              cart: parsedState,
              sectionId: this.dataset.source,
            },
          })
        );

        this.classList.toggle("is-empty", parsedState.item_count === 0);

        // dispatch cart:change for the entire basket
        document.dispatchEvent(
          new CustomEvent("cart:change", {
            detail: {
              cart: parsedState,
              sectionId: this.dataset.source,
            },
          })
        );

        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;

        document.dispatchEvent(
          new CustomEvent("cart:error", {
            detail: {
              source: this.dataset.source,
              productVariantId: items[line - 1].dataset.variantId || line,
              errors: window.cartStrings.error,
              message: window.cartStrings.error,
            },
          })
        );
      })
      .finally(() => {
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        if (document.querySelector(".cart-shipping")) {
          this.cartShipping();
        }
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-discount-code")) {
  class CartDiscountCode extends HTMLElement {
    /** @type {AbortController | null} */
    #activeFetch = null;

    connectedCallback() {
      this.#initRefs();
      this.form = this.querySelector("form");
      this.input = this.querySelector('input[name="discount"]');
      this.submitBtn = this.querySelector(".cart-discount-code__submit");
      this.#injectLoader();

      this.form?.addEventListener("submit", this.applyDiscount);
      this.submitBtn?.addEventListener("click", this.applyDiscount);
      this.addEventListener("click", this.removeDiscount);
    }

    disconnectedCallback() {
      this.form?.removeEventListener("submit", this.applyDiscount);
      this.submitBtn?.removeEventListener("click", this.applyDiscount);
      this.removeEventListener("click", this.removeDiscount);
      this.#activeFetch?.abort();
      this.#activeFetch = null;
    }

    #initRefs() {
      this.refs = {};
      for (const el of this.querySelectorAll("[ref]")) {
        const name = el.getAttribute("ref");
        if (name && el instanceof HTMLElement) this.refs[name] = el;
      }
    }

    #injectLoader() {
      if (!this.submitBtn || this.submitBtn.querySelector(".button__loader")) return;
      const loader = document.createElement("div");
      loader.className = "button__loader";
      loader.innerHTML =
        '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="5" cx="33" cy="33" r="30"></circle></svg>';
      this.submitBtn.appendChild(loader);
    }

    get #domId() {
      return this.dataset.sectionId === "cart-drawer"
        ? "CartDrawer"
        : `shopify-section-${this.dataset.sectionId}`;
    }

    #signal() {
      this.#activeFetch?.abort();
      const controller = new AbortController();
      this.#activeFetch = controller;
      return controller.signal;
    }

    #setLoading(on) {
      this.submitBtn?.classList.toggle("loading", on);
      if (this.submitBtn) this.submitBtn.disabled = on;
      if (this.input) this.input.disabled = on;
    }

    #clearErrors() {
      this.refs.cartDiscountError?.classList.add("hidden");
      this.querySelectorAll(".cart-discount-code__error-text").forEach((el) =>
        el.classList.add("hidden")
      );
    }

    #showError(type) {
      const refs = {
        discount_code: "cartDiscountErrorDiscountCode",
        shipping: "cartDiscountErrorShipping",
        empty: "cartDiscountErrorEmpty",
        already_applied: "cartDiscountErrorAlreadyApplied",
        network: "cartDiscountErrorNetwork",
      };
      this.refs.cartDiscountError?.classList.remove("hidden");
      this.refs[refs[type]]?.classList.remove("hidden");
    }

    #existingCodes() {
      return Array.from(this.querySelectorAll(".cart-discount-code__pill"))
        .filter((el) => el instanceof HTMLLIElement && typeof el.dataset.discountCode === "string")
        .map((el) => el.dataset.discountCode);
    }

    #isApplicable(discountCodes, code) {
      if (discountCodes.find((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable === false)) {
        if (this.input) this.input.value = "";
        this.#showError("discount_code");
        return false;
      }
      return true;
    }

    #isShippingCode(discountCodes, code, section) {
      const rendered = Array.from(section?.querySelectorAll(".cart-discount-code__pill") ?? [])
        .filter((el) => el instanceof HTMLLIElement)
        .map((el) => el.dataset.discountCode)
        .filter(Boolean);

      const existing = this.#existingCodes();

      if (
        rendered.length === existing.length &&
        rendered.every((c) => existing.includes(c)) &&
        discountCodes.find((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable === true)
      ) {
        this.#showError("shipping");
        if (this.input) this.input.value = "";
        return true;
      }
      return false;
    }

    #parseSection(sections) {
      const html = sections?.[this.dataset.sectionId];
      if (!html) return null;
      return new DOMParser().parseFromString(html, "text/html").getElementById(this.#domId);
    }

    #applySection(section) {
      if (!section) return;
      const target = document.getElementById(this.#domId);
      if (!target) return;

      if (this.closest("cart-drawer-inner-modal")?.hasAttribute("open")) {
        target.dataset.restoreInnerModal = "1";
      }

      target.innerHTML = section.innerHTML;
      delete target.dataset.restoreInnerModal;
    }

    applyDiscount = async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (this.submitBtn?.disabled) return;

      if (
        !(this.form instanceof HTMLFormElement) ||
        !(this.input instanceof HTMLInputElement) ||
        typeof this.dataset.sectionId !== "string"
      ) return;

      this.#clearErrors();

      const code = this.input.value.trim().toLowerCase();
      if (!code) {
        this.#showError("empty");
        this.input.focus();
        return;
      }

      const existing = this.#existingCodes();
      if (existing.some((c) => c.toLowerCase() === code)) {
        this.#showError("already_applied");
        return;
      }

      const signal = this.#signal();
      this.#setLoading(true);

      try {
        const response = await fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            discount: [...existing, code].join(","),
            sections: [this.dataset.sectionId],
          }),
          signal,
        });

        if (!response.ok) { this.#showError("network"); return; }

        const data = await response.json();

        if (!this.#isApplicable(data.discount_codes, code)) return;

        const section = this.#parseSection(data.sections);
        if (section) {
          if (this.#isShippingCode(data.discount_codes, code, section)) return;
          this.#activeFetch = null;
          this.#applySection(section);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("CartDiscountCode.applyDiscount:", err);
          this.#showError("network");
        }
      } finally {
        this.#activeFetch = null;
        this.#setLoading(false);
      }
    };

    removeDiscount = async (event) => {
      if (typeof this.dataset.sectionId !== "string") return;

      const pill =
        event.target instanceof Element
          ? event.target.closest(".cart-discount-code__pill")
          : null;
      if (!(pill instanceof HTMLLIElement)) return;

      event.preventDefault();
      event.stopPropagation();

      const code = pill.dataset.discountCode;
      if (!code) return;

      const existing = this.#existingCodes();
      const idx = existing.indexOf(code);
      if (idx === -1) return;

      existing.splice(idx, 1);

      const pillBtn = pill.querySelector(".cart-discount-code__pill-button");
      if (pillBtn) pillBtn.disabled = true;

      const signal = this.#signal();

      try {
        const response = await fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            discount: existing.join(","),
            sections: [this.dataset.sectionId],
          }),
          signal,
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        this.#activeFetch = null;
        this.#applySection(this.#parseSection(data.sections));
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("CartDiscountCode.removeDiscount:", err);
          this.#showError("network");
          if (pillBtn) pillBtn.disabled = false;
        }
      } finally {
        this.#activeFetch = null;
      }
    };
  }

  customElements.define("cart-discount-code", CartDiscountCode);
}

if (!customElements.get("cart-drawer-inner-modal")) {
  class CartDrawerInnerModal extends HTMLElement {
    constructor() {
      super();
      this.onOpen = this.onOpen.bind(this);
      this.onClose = this.onClose.bind(this);
    }

    connectedCallback() {
      this.openBtn = this.querySelector(".cart-drawer-inner-modal__open");
      this.closeBtn = this.querySelector(".cart-drawer-inner-modal__close");

      this.openBtn?.addEventListener("click", this.onOpen);
      this.closeBtn?.addEventListener("click", this.onClose);

      const cartDrawer = this.closest("[data-restore-inner-modal]");
      if (cartDrawer) {
        delete cartDrawer.dataset.restoreInnerModal;
        this.setAttribute("open", "");
        this.openBtn?.setAttribute("aria-expanded", "true");
      }
    }

    disconnectedCallback() {
      this.openBtn?.removeEventListener("click", this.onOpen);
      this.closeBtn?.removeEventListener("click", this.onClose);
    }

    onOpen() {
      if (this.hasAttribute("open")) { this.onClose(); return; }

      document.querySelectorAll("cart-drawer-inner-modal").forEach((m) => {
        if (m !== this) m.onClose?.();
      });

      this.setAttribute("open", "");
      this.openBtn?.setAttribute("aria-expanded", "true");
    }

    onClose() {
      this.removeAttribute("open");
      this.openBtn?.setAttribute("aria-expanded", "false");
    }
  }

  customElements.define("cart-drawer-inner-modal", CartDrawerInnerModal);
}

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.spinnerIcon =
          this.querySelector(".cart__note-loading") ||
          this.querySelector(".cart-drawer__note-loading");
        this.textarea = this.querySelector("textarea");
        this.cartButtons = document.querySelector(".cart__ctas");

        this.textarea.addEventListener(
          "input",
          debounce((event) => {
            this.spinnerIcon.style.display = "block";
            this.cartButtons.style.pointerEvents = "none";
            this.cartButtons.style.opacity = "0.7";

            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .catch((error) => {
                console.error(
                  "There was a problem with the fetch operation:",
                  error
                );
              })
              .finally(() => {
                this.spinnerIcon.style.display = "none";
                this.cartButtons.removeAttribute("style");
              });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
